import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_4_1_4 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.4 Case 4</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="challenge_case_4"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 4. This is a positive case.
                Beginning at the level of the temporal and occipital regions,
                distinct white matter tracts are not delineated on the left- or
                right-hand side. Increased activity is seen within the gray
                matter resulting in loss of gray-white contrast.
              </p>
              <p>
                Overall, there is patchy distribution of tracer, which persists
                as we enter into the frontal cortex, seen here. At this level,
                there is increased activity within the gray matter. In addition,
                white matter tracts are not clearly delineated. Although there
                are multiple foci of focal activity, they do not clearly
                correspond to white matter tracts.
              </p>
              <p>
                Continuing upwards and entering into the parietal region seen
                here, white matter tracts are not easily identifiable, moving
                from the front of the brain to the back of the brain on the
                left- or right-hand side. In addition, there is loss of
                gray-white contrast in the lateral and posterior parietal
                regions bilaterally. In the superior parietal region, there may
                appear to be preserved gray-white contrast on the right-hand
                side.
              </p>
              <p>
                However, when utilizing the accompanying fused PET/CT images,
                this area corresponds to a large CSF space. In the cortex
                immediately adjacent, there’s loss of gray-white contrast. After
                reviewing the remainder of the parietal images, there continues
                to be loss of gray-white contrast as well.
              </p>
              <p>
                This case is positive, as there is loss of gray-white contrast
                in multiple regions. If you called this case negative, you may
                want to review the case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-3"
          nextLesson="/module-4/module-4-1-5"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_2125855686&entry_id=1_bf143iht&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_bf143iht"
        />
      </main>
    </div>
  );
};

export default Module_4_1_4;
